<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content class="mat-typography">
    <div [innerHTML]="content"></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close [hidden]="hideCancelButton">{{cancelButtonText}}</button>
    <button mat-button [mat-dialog-close]="true" [hidden]="hideSubmitButton">{{submitButtonText}}</button>
</mat-dialog-actions>